<template>
  <el-form
    :model="form"
    :disabled="disabled"
    ref="form">
    <h3 class="blue-text">{{L10n('repair-exchange-td-report')}}</h3>
    <slot name="user-actions">
    </slot>

    <el-row :gutter="24">
      <el-col :sm="8" :span="12">
        <el-form-item
          :label="L10n('part-number')"
          prop="partID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-part-number
            :model.sync="form.partID"
            disabled
            @on-change="autoSave( 'partID', { required: true })"
          ></select-part-number>
        </el-form-item>
      </el-col>
      <el-col :sm="8" :span="12">
        <el-form-item
          :label="L10n('part-sn')"
          prop="partSN"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.partSN"
            @input="form.partSN = valueTrimLeft($event)"
            disabled
            @change="autoSave( 'partSN', { required: true })"
          />
        </el-form-item>
      </el-col>
      <el-col :sm="8" :span="12">
        <el-form-item
          :label="L10n('type-of-operation')"
          prop="typeOfOperationID"
          class="material-style"
        >
          <select-response
            :model.sync="form.typeOfOperationID"
            @on-change="autoSave( 'typeOfOperationID')"
            :isLoading="dataSourceTypeOfOperation.loading"
            :data="dataSourceTypeOfOperation.records"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :sm="6" :span="12">
        <el-form-item
          :label="L10n('entry-date')"
          prop="entryDate"
          class="material-style"
        >
          <date-picker
            v-model="form.entryDate"
            @change="autoSave('entryDate')"
          ></date-picker>
        </el-form-item>
      </el-col>
      <el-col :sm="6" :span="12">
        <el-form-item
          :label="L10n('receive-date')"
          prop="baxReceiveDate"
          class="material-style"
        >
          <date-picker
            v-model="form.baxReceiveDate"
            @change="autoSave('baxReceiveDate')"
          ></date-picker>
        </el-form-item>
      </el-col>
      <el-col :sm="6" :span="12">
        <el-form-item
          :label="L10n('lead-time')"
          prop="leadTime"
          class="material-style"
        >
          <date-picker
            v-model="form.leadTime"
            @change="autoSave('leadTime')"
          ></date-picker>
        </el-form-item>
      </el-col>
      <el-col :sm="6" :span="24">
        <el-form-item
          :label="L10n('customer-approval-date')"
          prop="customerApprovalDate"
          class="material-style"
        >
          <date-picker
            v-model="form.customerApprovalDate"
            @change="autoSave('customerApprovalDate')"
          ></date-picker>
        </el-form-item>
      </el-col>
    </el-row>

    <div class="row">
      <div class="col-md-4 col-6">
        <div class="row">
          <div class="col-12">
            <h4>{{L10n('repair-shop')}}</h4>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('currency-rs')"
              prop="rsCurrencyID"
              class="material-style"
              :rules="getValidationRule('required')"
            >
              <form-item-desc>
                <select-response
                  :model.sync="form.rsCurrencyID"
                  @on-change="autoSave('rsCurrencyID', { required: true })"
                  :isLoading="dataSourceCurrency.loading"
                  :data="dataSourceCurrency.records"
                ></select-response>
                <template v-slot:desc>
                  {{L10n('currency-bax-quote')}}
                </template>
              </form-item-desc>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('rs-labor-cost')"
              prop="rsLaborCost"
              class="material-style"
            >
              <form-item-desc>
                <el-input
                  :value="form.rsLaborCost"
                  @input="form.rsLaborCost = valueNumber($event)"
                  @change="handleChangeCost( 'rsLaborCost')"
                />
                <template v-slot:desc>
                  {{L10n('rs-labor-cost-desc')}}
                </template>
              </form-item-desc>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('rs-parts-cost')"
              prop="rsPartsCost"
              class="material-style"
            >
              <form-item-desc>
                <el-input
                  :value="form.rsPartsCost"
                  @input="form.rsPartsCost = valueNumber($event)"
                  @change="handleChangeCost( 'rsPartsCost')"
                />
                <template v-slot:desc>
                  {{L10n('rs-parts-cost-desc')}}
                </template>
              </form-item-desc>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('rs-total-cost')"
              prop="rsTotalCost"
              class="material-style"
              :rules="getValidationRule('required')"
            >
              <form-item-desc>
                <el-input
                  :value="form.rsTotalCost"
                  @input="form.rsTotalCost = valueNumber($event)"
                  @change="autoSave( 'rsTotalCost', { required: true })"
                />
                <template v-slot:desc>
                  {{L10n('rs-total-cost-desc')}}
                </template>
              </form-item-desc>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-6">
        <div class="row">
          <div class="col-12">
            <h4>{{L10n('bax')}}</h4>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('bax-currency')"
              prop="baxCurrencyID"
              class="material-style"
            >
              <form-item-desc>
                <select-response
                  :model.sync="form.baxCurrencyID"
                  @on-change="autoSave('baxCurrencyID')"
                  :isLoading="dataSourceCurrency.loading"
                  :data="dataSourceCurrency.records"
                ></select-response>

                <template v-slot:desc>
                  {{L10n('currency-bax-quote')}}
                </template>
              </form-item-desc>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('bax-labor-cost')"
              prop="baxCurrencyID"
              class="material-style"
            >
              <form-item-desc>
                <el-input
                  :value="form.baxLaborCost"
                  @input="form.baxLaborCost = valueNumber($event)"
                  @change="handleChangeBaxCost( 'baxLaborCost')"
                />
                <template v-slot:desc>
                  {{L10n('repair-plus-handling')}}
                </template>
              </form-item-desc>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('bax-parts-cost')"
              prop="baxPartsCost"
              class="material-style"
            >
              <form-item-desc>
                <el-input
                  :value="form.baxPartsCost"
                  @input="form.baxPartsCost = valueNumber($event)"
                  @change="handleChangeBaxCost( 'baxPartsCost')"
                />
                <template v-slot:desc>
                  {{L10n('shipping-plus-duties')}}
                </template>
              </form-item-desc>
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('bax-total-cost')"
              prop="baxTotalCost"
              class="material-style"
              :rules="getValidationRule('required')"
            >
              <form-item-desc>
                <el-input
                  :value="form.baxTotalCost"
                  @input="form.baxTotalCost = valueNumber($event)"
                  @change="autoSave( 'baxTotalCost', { required: true })"
                />
                <template v-slot:desc>
                  {{L10n('total-to-invoice')}}
                </template>
              </form-item-desc>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12">
        <div class="row">
          <div class="col-12">
            <h4 style="color: transparent">_</h4>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('inspection-fee')"
              prop="inspectionFee"
              class="material-style"
            >
              <el-input
                :value="form.inspectionFee"
                @input="form.inspectionFee = valueInteger($event)"
                @change="autoSave( 'inspectionFee')"
              />
            </el-form-item>
          </div>
          <div class="col-12">
            <el-form-item
              :label="L10n('remarks')"
              prop="remarks"
              class="material-style"
            >
              <el-input
                type="textarea"
                :value="form.remarks"
                @input="form.remarks = valueTrimLeft($event)"
                @change="autoSave( 'remarks')"
                rows="5"
              />
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="col-12">
        <el-form-item
          :label="L10n('rs-finding')"
          prop="rsFinding"
          class="material-style"
        >
          <el-input
            :value="form.rsFinding"
            @input="form.rsFinding = valueTrimLeft($event)"
            @change="autoSave( 'rsFinding')"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormRepairReport',
  mixins: [Form],
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'form-item-desc': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/FormItemDesc.vue')
  },
  computed: {
    dataSourceTypeOfOperation () {
      return this.API('TypeOfOperations/GetAllDynamic?select=id,title')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    }
  },
  methods: {
    handleChangeCost (field) {
      this.$nextTick(() => {
        let rsLaborCost = Number(this.form.rsLaborCost || 0)
        let rsPartsCost = Number(this.form.rsPartsCost || 0)
        let rsTotalCost = parseFloat(Number(rsLaborCost + rsPartsCost).toFixed(2))
        this.autoSave(field, { payloadData: { rsLaborCost, rsPartsCost, rsTotalCost } })
      })
    },
    handleChangeBaxCost (field) {
      this.$nextTick(() => {
        let baxLaborCost = Number(this.form.baxLaborCost || 0)
        let baxPartsCost = Number(this.form.baxPartsCost || 0)
        let baxTotalCost = parseFloat(Number(baxLaborCost + baxPartsCost).toFixed(2))
        this.autoSave(field, { payloadData: { baxLaborCost, baxPartsCost, baxTotalCost } })
      })
    }
  }
}
</script>
